<div class="m-2">
  <div class="tree-controls">
    <p-button 
      icon="pi pi-plus" 
      label="Expand All"
      styleClass="p-button-sm p-button-text"
      (onClick)="expandAll()"
      pTooltip="Expand all nodes"
      tooltipPosition="top"
    ></p-button>
    <p-button 
      icon="pi pi-minus" 
      label="Collapse All"
      styleClass="p-button-sm p-button-text"
      (onClick)="collapseAll()"
      pTooltip="Collapse all nodes (root stays expanded)"
      tooltipPosition="top"
    ></p-button>
  </div>
  <p-tree
    [value]="treeData"
    [draggableNodes]="true"
    [droppableNodes]="true"
    (onNodeDrop)="onNodeDrop($event)"
    (onNodeDragEnd)="onNodeDragEnd($event)"
  ></p-tree>
</div>
